// eslint-disable-next-line import/no-cycle
import bffApi, {BffResponse} from '@client/bffApi';
import {ClientService, GetThirdPartyUserOptions, ThirdPartyUser} from '@simpleinvest/ms-client-sdk';
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';
import {SsoEnrollRequest} from './request/ServiceRequest';
import {SsoEnrollResponse} from './response/ServiceResponse';

export default {
  getClientServiceInstance(): ClientService {
    return new ClientService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },
  async cognitoSsoLogin(payload: SsoEnrollRequest): Promise<BffResponse<SsoEnrollResponse>> {
    const {data} = await bffApi
      .getAxiosInstance()
      .post<BffResponse<SsoEnrollResponse>>(`${bffApi.getBaseUrl(true)}/client-onboarding/firms/sso/enroll`, payload);

    return data;
  },
  async getOnboardingData(options: GetThirdPartyUserOptions): Promise<ThirdPartyUser> {
    const service: ClientService = await this.getClientServiceInstance();

    const response = await service.getThirdPartyUser(options);

    return response;
  },
};
